import { render, staticRenderFns } from "./ProfileForVerifier.vue?vue&type=template&id=65ba4144"
import script from "./ProfileForVerifier.vue?vue&type=script&lang=js"
export * from "./ProfileForVerifier.vue?vue&type=script&lang=js"
import style0 from "./ProfileForVerifier.vue?vue&type=style&index=0&id=65ba4144&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports